module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_3016.032e9563.png";